import React from 'react';
const ReplyMessageIcon = ({ fill, width, height, opacity }) => (
    <svg className="icon reply-message-icon" width={width} height={height} viewBox="0 0 17 16">
        <path
            fill={fill}
            opacity={opacity}
            d="M16.147 14.503c-.18 0-.35-.097-.439-.26l-.014-.026c-1.495-2.7-4.344-4.38-7.435-4.38h-.945V13c0 .2-.12.382-.306.46-.183.078-.399.04-.542-.101l-5.667-5.5C.702 7.765.647 7.635.647 7.5c0-.135.055-.265.152-.359l5.667-5.5c.144-.14.36-.18.542-.102.185.079.306.26.306.461v3.16c5.162.09 9.333 3.66 9.333 8.843 0 .229-.155.428-.376.485-.041.01-.083.015-.124.015z"
        />
    </svg>
);

export default ReplyMessageIcon;
